import Vue from 'vue';
// core
import BzbsApi from '@/core/Http/BzbsApi.js';
import { SearchHistoryModel } from '../model/SearchHistoryModel.js';
// helper
import Util from '@/helper/Utility.js';

export default {
    config: function () {
        return Vue.bzbsConfig;
    },
    apiGetCampaignSearchHistory: function (token, top) {
        let params = {
            type: 'campaign',
            top: top || 10,
            lastRowKey: null
        };
        params = Util.cleanObjectEmptyStr(params);

        const url = this.config().bzbsUrl + '/history/search';
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(url, token, params).then((response) => {
                let list = [];
                let res = response.data;
                for (let item of res) {
                    const newItem = new SearchHistoryModel(item);
                    list.push(newItem);
                }

                resolve(list);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    apiClearCampaignSearchHistory: function (token) {
        const url = this.config().bzbsUrl + '/history/clear';
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(url, token, null).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
}
